"use strict";

exports.__esModule = true;

exports.default = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/helpers/newArrowCheck.js
// module id = 15
// module chunks = 0